<template>
	<div class="margin-left">
		<div class="today flex flex-direction">
			<p class="title solid-bottom text-lg text-left">今日获取积分</p>
			<div class="flex flex-direction justify-center align-center flex-sub">
				<p class="num text-theme">{{integral || 0}}</p>
				<p class="recordbtn text-theme margin-top-sm pointer" @click="godetail('integralrecord','integral')">积分记录</p>
			</div>
		</div>
		<div>
			<p class="text-333 fs24 text-left margin-top margin-bottom-sm">我的任务</p>
			<div class="allwidth">
				<el-row :gutter="10">
					<el-col :span="12" v-if="is_subscribe == 0">
						<div class="flex align-center justify-between bg-white obtain-item padding-lr-sm margin-bottom-sm" @click="godetail('idcard')">
							<div class="flex">
								<img class="block-55 margin-right-xs" src="../../../assets/img/task/task-id.png" >
								<div class="flex flex-direction justify-between align-start">
									<p>实名认证</p>
									<p>新手实名认证后获取{{integral_real}}积分</p>
								</div>
							</div>
							<p class="btn real text-white pointer">去实名</p>
						</div>
					</el-col>
					<el-col :span="12">
						<div class="flex align-center justify-between bg-white obtain-item padding-lr-sm margin-bottom-sm" @click="godetail('share')">
							<div class="flex">
								<img class="block-55 margin-right-xs" src="../../../assets/img/task/task-inve.png" >
								<div class="flex flex-direction justify-between align-start">
									<p>邀请好友</p>
									<p>每邀请一位好友注册，可获{{integral_share}}积分</p>
								</div>
							</div>
							<p class="btn bg-theme text-white pointer">去邀请</p>
						</div>
					</el-col>
					<el-col :span="12" v-if="status == 0">
						<div class="flex align-center justify-between bg-white obtain-item padding-lr-sm margin-bottom-sm" @click="godetail('frequency')">
							<div class="flex">
								<img class="block-55 margin-right-xs" src="../../../assets/img/task/task-video.png" >
								<div class="flex flex-direction justify-between align-start">
									<p>录制视频</p>
									<p>拍摄视频简历获取{{integral_video}}积分 </p>
								</div>
							</div>
							<p class="btn recording text-white pointer">去上传</p>
						</div>
					</el-col>
				</el-row>
			</div>
		</div>
		<div class="contact">如有疑问请联系平台客服：<span class="text-theme">400-212-22</span></div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				integral:'',//
				integral_real:'',
				integral_share:'',
				integral_video:'',
				is_subscribe:0,//实名状态
				status:'',//视频状态
			};
		},
		created() {
			this.getTaskAll()
			this.getTaskIntegral()
			this.getvideo()
			this.getren()
		},
		methods: {
			
			//通知center 跳转对应页面
			godetail(index,one){
				let typeone = one?one:''
				let type = {
					type:index,
					typeone:typeone
				}
				this.$emit('gettype',type)
			},
			//获取任务积分
			getTaskIntegral(){
				this.ajax('get', '/api/system/getTaskIntegral', {},res => {
					console.log(res.data);
					this.integral_share = res.data.integral_share
					this.integral_real = res.data.integral_real
					this.integral_video = res.data.integral_video
				})
			},
			/**
			 * 获取今日任务所得积分
			 * */
			getTaskAll(){
				this.ajax('get', '/api/integral/getTaskAll', {}, res => {
					console.log(res);
					if(res.status == 200){
						this.integral = res.data.integral || 0
						
					}
				})
				
			},
			/**
			 * 获取实名认证状态
			 * */
			getren(){
				this.ajax('get', '/api/userReal/getReal', {
					type:1
				}, res => {
					console.log(res);
					if(res.status == 200){
						this.is_subscribe = res.data.is_real
					}
				})
			},
			/**
			 * 获取工作视频的状态
			 * */
			getvideo(){
				this.ajax('get', '/api/userVideo/getvideo', {}, res => {
					if(res.status == 200){
						this.status = res.data.video.status||0
					}
				})
			},
		}
	}
</script>

<style scoped lang="less">
	.today{
		width: 321px;
		height: 244px;
		background: #FFFFFF;
		box-shadow: -4px 3px 19px 1px rgba(204,204,204,0.2);
		border-radius: 20px;
		.title{
			padding: 30px 29px 18px;
		}
		.num{
			font-size: 42px;
		}
		.recordbtn{
			width: 104px;
			height: 35px;
			line-height: 35px;
			background: #FFFFFF;
			border: 1px solid #09827B;
			border-radius: 18px;
		}
	}
	.fs24{
		font-size: 24px;
	}
	.allwidth{
		width: 918px;
		.obtain-item{
			width: 450px;
			height: 114px;
			background: #FFFFFF;
			box-shadow: -4px 3px 19px 1px rgba(204,204,204,0.2);
			border-radius: 20px;
		}
		.platform{
			width: 918px;
			height: 73px;
			line-height: 73px;
			background: #FFFFFF;
			box-shadow: -4px 3px 19px 1px rgba(204,204,204,0.2);
			border-radius: 20px;
		}
		.btn{
			width: 106px;
			height: 38px;
			line-height: 38px;
			border-radius: 19px;
		}
		.real{
			background: #50BDFD;
		}
		.recording{
			background: #FB706C;
		}
	}
	.contact{
		width: 918px;
		height: 73px;
		line-height: 73px;
		background: #FFFFFF;
		box-shadow: -4px 3px 19px 1px rgba(204,204,204,0.2);
		border-radius: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/components/my/task/task.vue